import type { SVGProps } from 'react';
const DawnFlagTL = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-TL_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-TL_svg__a)">
      <path fill="#FF323E" d="M0 0h22v16H0z" />
      <path
        fill="#FFCC51"
        fillRule="evenodd"
        d="m0 0 13.619 8L0 16z"
        clipRule="evenodd"
      />
      <path fill="#262626" fillRule="evenodd" d="m0 0 9.429 8L0 16z" clipRule="evenodd" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m4.67 8.66-.695 1.55-.363-1.664-1.663-.193 1.442-.866-.333-1.67 1.254 1.129 1.458-.84-.667 1.564 1.234 1.152z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagTL;
